import script from "./ImageViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageViewer.vue?vue&type=script&setup=true&lang=ts"

import "./ImageViewer.vue?vue&type=style&index=0&id=265c4414&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265c4414"]])

export default __exports__